export default __webpack_public_path__ + "static/media/rotate_frame_layout.adca7850.svg";